<template>
  <v-container fill-height class="ma-0 pa-0">
    <RequestPasswordReset v-if="!token"/>
    <ResetPassword v-if="token" :token="token"></ResetPassword>
  </v-container>
</template>

<script>
import RequestPasswordReset from '../components/dialogs/RequestPasswordReset'
import ResetPassword from '../components/dialogs/ResetPassword'

export default {
	name: 'PasswordReset',
	components: { ResetPassword, RequestPasswordReset },
	data () {
		return {
			token: ''
		}
	},
	mounted () {
		const pathQuery = this.$route.query
		if (pathQuery && 'token' in pathQuery) {
			this.token = pathQuery.token
		}
	}
}
</script>

<style scoped>
.container{
	max-width: 100% !important;
}
</style>
